<template>
  <transition @before-enter="beforeEnter" @enter="enter" @leave="leave" :css="false" appear>
    <section :class="this.name">
      <div class="bg"></div>
      <div class="content">
      </div>
    </section>
  </transition>
</template>
<script>
    import BasePage from './mixins/basePage.js';
    import {rePostionContents, reSizeBackground} from "@/utils/cavasResize";


    export default {
        name: 'home',
        mixins:[BasePage],
        data() {
            return {
                name:'home',
                contentData:[
                    //{type:'bg', source:this.$staticUrl+'img/bg_1.jpg', objName:'bg'}
                    {type:'bg', source:'https://vod.plaync.com/lineage/remaster0320/0320_remaster_bg1.mp4', objName:'bgmovie'}
                ]
            };
        },
        methods: {
            canvasSet(){
                this.baseCavasSet(this.contentData);
                let textureArray = [];
                for (let i=0; i < 199; i++)
                {
                    let texture = PIXI.Texture.fromImage(this.$staticUrl+`img/logo_intro/start_${i}.png`);
                    textureArray.push(texture);
                };

                this.cvObj.logoIntro = new PIXI.extras.AnimatedSprite(textureArray);
                this.cvObj.logoIntro.anchor.set(0.5, 0);
                this.cvObj.logoIntro.x = this.contentSize.w/2 ;
                this.cvObj.logoIntro.y = 218 ;
                this.cvObj.logoIntro.loop  = false;
                this.cvObj.logoIntro.autoPlay  = false;
                this.cvObj.logoIntro.animationSpeed = 0.4;
                this.cvObj.con.addChild(this.cvObj.logoIntro);

                this.cvObj.logoIntro.onComplete = ()=>{
                    this.cvObj.logoIntro.alpha = 0;
                    this.cvObj.logoLoop.alpha = 1;
                    this.cvObj.logoLoop.play();
                }

                let textureArray2 = [];

                for (let i=0; i < 59; i++)
                {
                    let texture2 = PIXI.Texture.fromImage(this.$staticUrl+`img/logo_loop/loop_${i}.png`);
                    textureArray2.push(texture2);
                };

                this.cvObj.logoLoop = new PIXI.extras.AnimatedSprite(textureArray2);
                this.cvObj.logoLoop.anchor.set(0.5, 0);
                this.cvObj.logoLoop.alpha = 0;
                this.cvObj.logoLoop.x = this.contentSize.w/2 ;
                this.cvObj.logoLoop.y = 218 ;
                this.cvObj.logoLoop.animationSpeed = 0.4
                this.cvObj.con.addChild(this.cvObj.logoLoop);

                this.cvObj.subTitle = new PIXI.Sprite.fromImage(this.$staticUrl+'img/txt_1_stit.png');
                this.cvObj.subTitle.anchor.set(0.5, 0);
                this.cvObj.subTitle.x = this.contentSize.w/2 ;
                this.cvObj.subTitle.y = 635 ;

                this.cvObj.con.addChild(this.cvObj.subTitle);

                this.cvObj.quick_btn = new PIXI.Sprite.fromImage(this.$staticUrl+'img/btn_1.png');
                this.cvObj.quick_btn.anchor.set(1, 0);
                this.cvObj.quick_btn.x = this.w-70 ;
                this.cvObj.quick_btn.y = 430 ;
                this.canvas.stage.addChild(this.cvObj.quick_btn);
                this.cvObj.quick_btn.interactive = true;
                this.cvObj.quick_btn.cursor = 'pointer';
                this.cvObj.quick_btn.pointerdown = (e)=>{
                    window.trackBtnClick('업데이트 런칭 이벤트 미리보기');
                    window.location = '/events/2019/190320_remaster/coupon';
                };
                this.cvObj.quick_btn.pointerover = function(e){
                    TweenMax.to(this, 0.5, { pixi: { brightness : 1.5 }})
                };
                this.cvObj.quick_btn.pointerout = function(e){
                    TweenMax.to(this, 0.2, { pixi: { brightness : 1 }})
                };

                this.cvObj.obj_icon = new PIXI.Sprite.fromImage(this.$staticUrl+'img/ico_scroll.png');
                this.cvObj.obj_icon.anchor.set(0.5, 0);
                this.cvObj.obj_icon.x = this.w/2 ;
                this.cvObj.obj_icon.y = this.h - 180 ;
                this.canvas.stage.addChild(this.cvObj.obj_icon);
            },
            enter (el, done) {
                this.baseEnter();
                this.canvasSet();

                this.baseEnterMotion(el, done, this.contentData);

                TweenMax.set(this.cvObj.subTitle, {pixi: { alpha: 0 , brightness: 10} })
                TweenMax.set(this.cvObj.quick_btn, {pixi: { alpha: 0 , brightness: 5} })
                TweenMax.set(this.cvObj.obj_icon, {pixi: { alpha: 0 , brightness: 5} })

                this.enterMotion.call(()=>{ this.cvObj.logoIntro.play()}, null, null, 'bgMotionEnd-=0.5')
                    .to(this.cvObj.subTitle, 3,{ pixi: { alpha: 1, brightness: 1},ease:Power0.easeNone}, 'bgMotionEnd+=3')
                    .to(this.cvObj.quick_btn, 1, { pixi: { alpha: 1, brightness: 1}, ease: Quart.easeOut}, 'bgMotionEnd+=4')
                    .to(this.cvObj.obj_icon, 1, { pixi: { alpha: 1, brightness: 1}, ease: Quart.easeOut}, 'bgMotionEnd+=4.2')


                //this.canvas.start();
                this.enterMotion.play();
            },
            leave (el, done) {
                if(this.enterMotion)this.enterMotion.pause();
                this.cvObj.logoLoop.stop();
                this.cvObj.logoIntro.stop();
                this.baseLeaveMotion(el, done);
            },
            resize(){
                this.w =  document.querySelector('.container').clientWidth;
                this.h = document.querySelector('.container').clientHeight;
                if(!this.canvas)return;
                reSizeBackground(this.cvObj.bg, this.w, this.h);
                rePostionContents(this.cvObj.con, this.w, this.h, this.contentSize.w, this.contentSize.h, true);
                this.cvObj.quick_btn.x = this.w-70 ;
                this.cvObj.obj_icon.x =  this.w/2 ;
                this.cvObj.obj_icon.y = this.h - 180 ;
                this.canvas.renderer.resize(this.w, this.h);

                this.documentSetSize({
                    width:this.w,
                    height:this.h
                });
            }
        }
    }
</script>





